<template>
  <div class="table-responsive relations-table">
    <table
      v-if="entityId && currentRelations.length"
      class="table table-striped"
    >
      <thead>
        <th style="min-width: 220px">Сущность на сайте</th>
        <th style="width: 220px">Тип сущности в ЛК</th>
        <th style="min-width: 220px">Сущность в ЛК</th>
        <th style="min-width: 220px">Название</th>
        <th style="width: 240px">Количество</th>
      </thead>
      <tbody>
        <tr v-for="relation of currentRelations" :key="relation.id">
          <td>{{ relation.site_entity_name }}</td>
          <td>{{ relation.fillable_type == "course" ? "Курс" : "Тест" }}</td>
          <td>{{ relation.fillable_name }}</td>
          <td>{{ relation.entity_name }}</td>
          <td
            v-if="editCountId == relation.id"
            class="flex align-item-center count-editing"
          >
            <custom-input
              v-model="editCount"
              type="number"
              name="count"
              :min="0"
              :inputWidth="100"
            />
            <button class="edit-btn" @click="updateRelation(relation)">
              <i class="fal fa-check"></i>
            </button>
            <button class="edit-btn" @click="editCountId = null">
              <img src="@/assets/images/icons/close.svg" alt="" />
            </button>
          </td>
          <td v-else>{{ relation.count }}</td>
          <td>
            <button
              @click="openEditingCount(relation.id, relation.count)"
              class="flex justify-content-between w-full edit-btn"
            >
              <i class="fal fa-pen"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref, toRef } from "@vue/runtime-core";
import { useStore } from "vuex";
import CustomInput from "../../components/Forms/Fields/CustomInput.vue";
import { notify } from "@kyvg/vue3-notification";
// import Preloader from '../Technical/Preloader.vue';
export default {
  components: { CustomInput },
  //   components: { Preloader },
  name: "relations-table",
  props: {
    entityId: {
      type: String,
    },
  },
  setup(props) {
    const store = useStore(),
      id = toRef(props, "entityId"),
      editCountId = ref(null),
      editCount = ref(null);
    const relations = computed(() => store.state.relations.relations),
      dictionaryEntities = computed(
        () => store.state.relations.dictionaryEntities
      ),
      dictionaryProducts = computed(
        () => store.state.relations.dictionaryProducts
      ),
      currentRelations = computed(() =>
        relations.value
          .filter((rel) => rel.site_entity_id == id.value)
          .map((rel) => {
            const additionalRel = rel;
            additionalRel["site_entity_name"] =
              dictionaryProducts.value[
                `${rel.site_entity_type}_${rel.site_entity_id}`
              ];
            additionalRel["fillable_name"] =
              dictionaryEntities.value[rel.fillable_id];
            return additionalRel;
          })
      );
    onBeforeMount(() => {
      store.dispatch("relations/getRelations");
    });

    const openEditingCount = (id, count) => {
      editCountId.value = id;
      editCount.value = count;
    };

    const updateRelation = (relation) => {
      if (!editCount.value) {
        notify({
          type: "error",
          title: "Поле должно быть заполнено",
        });
      } else {
        const data = relation;
        data.count = editCount.value;
        store
          .dispatch("relations/updateRelation", data)
          .then(() => (editCountId.value = null));
      }
    };

    return {
      id,
      relations,
      currentRelations,
      editCountId,
      dictionaryEntities,
      dictionaryProducts,
      editCount,
      updateRelation,
      openEditingCount,
    };
  },
};
</script>

<style scoped lang="scss">
.count-editing {
  .form-group {
    justify-content: flex-start;
    max-width: 130px;
    margin: 0;
  }
}
.relations-table {
  tr {
    height: 76px;
  }
}
</style>